import { StatusCodes } from '@e3dc-react/shell/Libs'
import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { AuthFetchWithResponse } from 'src/Types/api'
import { ShopAccessDto } from './dto/shop-access.dto'

/**
 * Fetches a list of countries that are allowed to access the web shop
 */
export const fetchAllowedCountriesForShop = async (authFetch: AuthFetchWithResponse): Promise<ApiResult<ShopAccessDto[]>> => {
  try {
    const response = await authFetch<ShopAccessDto[]>({
      path: `users/shop-accesses`,
      method: 'GET',
    })
    if (response.status === StatusCodes.OK) {
      return new ApiResult<ShopAccessDto[]>(response.data, false)
    }
    return new ApiResult<ShopAccessDto[]>(null, true)
  } catch (error) {
    return handleFetchError<ShopAccessDto[]>(error)
  }
}
